import { render, staticRenderFns } from "./ParentPayWait.vue?vue&type=template&id=0bb682b4&scoped=true&"
import script from "./ParentPayWait.vue?vue&type=script&lang=js&"
export * from "./ParentPayWait.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb682b4",
  null
  
)

export default component.exports